import { createAction } from 'redux-actions';

export const USER_SET_MODEL = 'USER_SET_MODEL';
export const USER_SET_INFO = 'USER_SET_INFO';
export const USER_SET_RESULT = 'USER_SET_RESULT';

export const userSetModel = createAction(USER_SET_MODEL);
export const userSetInfo = createAction(USER_SET_INFO);
export const userSetResult = createAction(USER_SET_RESULT);
